import { axios, handleApiErrors, getToken } from '../helpers'

export default (
  property_id = null,
  product_id = null,
  state = '-state:closed',
  filterText = null,
  limit = 10,
  offset = 0
) => {
  const token = getToken()

  const params = {
    token,
    limit,
    offset
  }

  if (property_id) {
    params.property_id = property_id
  }
  if (product_id) {
    params.product_id = product_id
  }

  let filter = `${state}`

  if (filterText) {
    filter += ` ${filterText.trim()}`
  }
  if (filter) {
    params.filter = filter
  }

  return axios
    .request({
      url: 'interactions',
      params
    })
    .then(handleApiErrors)
}
